import React, { useEffect, useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { AppShell } from './components/layout/AppShell';
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  useEffect(() => {
    // Set the document title
    document.title = 'EthBridge Bank Portal';
  }, []);
  const handleLogin = () => {
    setIsAuthenticated(true);
  };
  const handleLogout = () => {
    setIsAuthenticated(false);
  };
  if (!isAuthenticated) {
    return <LandingPage onLogin={handleLogin} data-id="element-0" />;
  }
  return <AppShell onLogout={handleLogout} data-id="element-1" />;
}